import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { useSelector } from 'react-redux';
import { getMerchCardsToShow } from '../../constants/merchCards/MerchCardsToShow';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useTierQueryParam } from '../../hooks/useTierQueryParam';
import { overrideStarterApiNames, useShowStarterCustomerPlatformUpsellCard } from '../../hooks/upsell/useStarterUpsell';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { productSelector } from '../../selectors/ProductsSelectors';
import { getNavItemForProductLine } from '../../utils/routingUtils';
import { BaseCardBadge } from '../../v2/components/merch-card/BaseCardBadge';
import { FREE_CARD } from '../../v2/constants/tracking/TrackingSources';
import { useBadges } from '../../v2/hooks/badges/useBadges';
import { useIsUngatedForPublicRemoveTabs } from '../../v2/hooks/gating/useIsUngated';
import PricingPlanToggleButton from '../../v2/components/PricingPlanToggleButton';
import { FreeCard } from './cards/FreeCard';
import { HubCard } from './cards/HubCard';
import { UpsellSuiteCard } from './cards/suite/UpsellSuiteCard';
import { StandardFeaturesContainer } from './features-display/features-display-containers/StandardFeaturesContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const HubTierInfo = ({
  productLine,
  selectedTab
}) => {
  const isAppReady = useGlobalLoading();
  const isAppAuth = useSelector(isAppAuthSelector);
  const isUngatedForPublicRemoveTabs = useIsUngatedForPublicRemoveTabs();
  const tier = useTierQueryParam();
  const screen = getNavItemForProductLine(productLine);
  const getProductLevels = () => {
    return getMerchCardsToShow({
      tab: selectedTab,
      tier,
      isUngatedForPublicRemoveTabs: !isAppAuth && isUngatedForPublicRemoveTabs
    });
  };
  const productLevels = getProductLevels();
  const isMobile = useIsMobile();
  const {
    showStarterCustomerPlatformUpsellCard,
    upsellStarterApiName,
    loading: upsellLoading
  } = useShowStarterCustomerPlatformUpsellCard(selectedTab);
  const hubPageStarterApiName = useAppSelector(state => {
    const starterProduct = productSelector(state, {
      productLine,
      productLevel: 'STARTER'
    });
    return starterProduct === null || starterProduct === void 0 ? void 0 : starterProduct.apiName;
  });
  const productsToShow = useAppSelector(state => {
    if (!isAppReady) return [];
    const products = productLevels.map(productLevel => {
      const product = productSelector(state, {
        productLine,
        productLevel
      });
      if (product !== null && product !== void 0 && product.apiName) return product.apiName;
      return null;
    });
    const filtered = products.filter(product => product !== null);
    return overrideStarterApiNames(filtered, showStarterCustomerPlatformUpsellCard, upsellStarterApiName);
  });
  const {
    badges,
    hasBadgeOnFirstColumn,
    hasBadgeOnLastColumn
  } = useBadges({
    productApiNames: productsToShow,
    skipOverride: !isAppReady || upsellLoading
  });
  const merchCardComponents = productLevels.map((productLevel, index) => {
    var _badges$productsToSho;
    const columnStart = index + 1;
    if (productLevel === 'FREE') {
      return /*#__PURE__*/_jsx(FreeCard, {
        productLine: productLine,
        columnStart: columnStart,
        trackingSource: FREE_CARD
      }, `${productLine}-${productLevel}`);
    }
    if (showStarterCustomerPlatformUpsellCard && productLevel === 'STARTER') {
      var _badges$upsellStarter;
      return /*#__PURE__*/_jsx(UpsellSuiteCard, {
        productLine: productLine,
        columnStart: columnStart,
        screen: screen,
        Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
          apiName: upsellStarterApiName,
          badgeName: badges === null || badges === void 0 || (_badges$upsellStarter = badges[upsellStarterApiName]) === null || _badges$upsellStarter === void 0 ? void 0 : _badges$upsellStarter.badgeName
        }),
        Features: /*#__PURE__*/_jsx(StandardFeaturesContainer, {
          productLine: productLine,
          productLevel: 'STARTER',
          productApiName: hubPageStarterApiName,
          isCollapsible: isMobile
        })
      }, `${productLine}-upsell-${productLevel}`);
    }
    return /*#__PURE__*/_jsx(HubCard, {
      productLevel: productLevel,
      productLine: productLine,
      selectedTab: selectedTab,
      columnStart: columnStart,
      Badge: /*#__PURE__*/_jsx(BaseCardBadge, {
        apiName: productsToShow[columnStart - 1],
        badgeName: badges === null || badges === void 0 || (_badges$productsToSho = badges[productsToShow[columnStart - 1]]) === null || _badges$productsToSho === void 0 ? void 0 : _badges$productsToSho.badgeName
      })
    }, `${productLine}-${productLevel}`);
  });
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(PageSection, {
      hideOverflow: false,
      children: [/*#__PURE__*/_jsx(MerchCardColumns, {
        columns: productLevels.length,
        hasBadgeOnFirstColumn: hasBadgeOnFirstColumn,
        hasBadgeOnLastColumn: hasBadgeOnLastColumn,
        children: merchCardComponents
      }), !isAppAuth && isUngatedForPublicRemoveTabs && /*#__PURE__*/_jsx(PricingPlanToggleButton, {
        tier: tier
      })]
    })
  });
};
export default HubTierInfo;